export enum ModalSize {
    Sm = 1,
    Md = 2,
    Lg = 3,
    Xl = 4
}